import { memo } from "react";
import {
  AddAccountGroup,
  AddAlertManagement,
  AddAlertTemplate,
  AddAreaMaster,
  AddAssetAccount,
  AddBankAccount,
  AddBankReceipt,
  AddBranch,
  AddCashPayment,
  AddcashReceipt,
  AddChargeMaster,
  AddCityMaster,
  AddClaimSale,
  AddClaimsComponent,
  AddCompany,
  AddConnectionCenter,
  AddDestinationInward,
  AddConnectionStatusUpdate,
  AddConsignmentNote,
  AddContra,
  AddCountryMaster,
  AddCustormerAccount,
  AddDebitNote,
  AddDeliveryPlanning,
  AddDistrictMaster,
  AddDriverAccount,
  AddEmtAccount,
  AddEmtMarketRate,
  AddEventMaster,
  AddFieldsMaster,
  AddFinancialMaster,
  AddFlightMaster,
  AddFormKey,
  AddFormSections,
  AddGodownMaster,
  AddHSN,
  AddInputFields,
  AddInwardConnection,
  AddJournalVoucher,
  AddKYCVerification,
  AddLedger,
  AddLicense,
  AddLMSSalesBill,
  Addload,
  AddLrBook,
  AddLrCenter,
  AddMenuMaster,
  AddModelTypeMaster,
  AddMyTruck,
  AddMyVehicleManagent,
  AddNewCreditNote,
  AddNominalAccount,
  AddPageMasterData,
  AddPaymentAccount,
  AddPaymentProcess,
  AddPaymentTermsMaster,
  AddPickupMemo,
  AddPincodeMaster,
  AddPlaceMaster,
  AddProductMaster,
  AddPurchaseBill,
  AddReceiptInfo,
  AddSalesBill,
  AddStateMaster,
  AddStockGroup,
  AddStockItem,
  AddSubMenuMaster,
  AddTableColumnManagement,
  AddTableKey,
  AddTMSTruckPost,
  AddTruckMaster,
  // AddMyLoad,
  AddUserEntry,
  AddUserPaymentTermsManagement,
  AddUserRole,
  AddVehicleCategoryMaster,
  AddVehicleLengthMaster,
  AddVehicleManagent,
  AddVehicleOwnerAccount,
  AddVehicleTypeMaster,
  AddVendorAccount,
  AddVoucherSeries,
  AddWarehouseMaster,
  AddZoneMaster,
  AddConnectionPlanning,
  CustomerLogs,
  Erp_UserLogById,
  ErrorUserLogs,
  LRPickupUpdationModal,
} from "../Components/FormComponents";
import { AddAdminRequestSupport } from "../Components/FormComponents/AddAdminRequestSupport/AddAdminRequestSupport";
import AddContactPersonMaster from "../Components/FormComponents/AddContactPersonMaster/AddContactPersonMaster";
import AddEMTDriverAccount from "../Components/FormComponents/AddEmtDriverAccounts/AddEMTDriverAccount";
import { AddERPAddressBookMaster } from "../Components/FormComponents/AddERPAddressBookMaster/AddERPAddressBookMaster";
import AddFreightBill from "../Components/FormComponents/AddFreightBill/AddFreightBill";
import AddFTLCNDelivery from "../Components/FormComponents/AddFTLCNDelivery/AddFTLCNDelivery";
import AddFTLConsignmentNote from "../Components/FormComponents/AddFTLConsignmentNote/AddFTLConsignmentNote";
import AddMyload from "../Components/FormComponents/AddMyLoad/AddMyload";
import MyShipmentMap from "../Components/FormComponents/AddMyShipmentTracking/MyShipmentMap";
import AddPartMaster from "../Components/FormComponents/AddPartMaster/AddPartMaster";

import AddServiceTypeMaster from "../Components/FormComponents/AddServiceTypeMaster/AddServiceTypeMaster";
import AddTaxPercentage from "../Components/FormComponents/AddTaxPercentage/AddTaxPerCentage";
import AddTHC from "../Components/FormComponents/AddTHC/AddTHC";
import AddTruck from "../Components/FormComponents/AddTruck/AddTruck";
import AddVesselMaster from "../Components/FormComponents/AddVesselMaster/AddVesselMaster";
import AddCNPickupUpdation from "../Components/FormComponents/LRPickupUpdation/AddCNPickupUpdation";
import Emt_UserLogById from "../Components/FormComponents/UserLogs/Emt_UserLogBYId";
import EditBookingPageModal from "../Pages/BookingPage/EditBookingPageModal";

import AddPackagingMaster from "../Components/FormComponents/AddPackagingMaster/AddPackagingMaster";
import AddTrainMaster from "../Components/FormComponents/AddTrainMaster/AddTrainMaster";

import AddBookingBroker from "../Components/FormComponents/AddBookingBroker/AddBookingBroker";
import AddCompliancesMaster from "../Components/FormComponents/AddCompliancesMaster/AddCompliancesMaster";
import AddMaterialCategory from "../Components/FormComponents/AddMaterialCategory/AddMaterialCategory";
import AddMyShipMentTracking from "../Components/FormComponents/AddMyShipmentTracking/AddMyShipmentTracking";
import AddOrionAppUser from "../Components/FormComponents/AddOrionAppUser/AddOrionUser";
import AddPrintLayout from "../Components/FormComponents/AddPrintLayout/AddPrintLayout";
import AddSalesReturn from "../Components/FormComponents/AddSalesReturn/AddSalesReturn";


import AddEmployeeAccount from "../Components/FormComponents/AddEmployeeAccount/AddEmployeeAccount";
import AddGeneralAccount from "../Components/FormComponents/AddGeneralAccount/AddGeneralAccount";
import AddPriceListMaster from "../Components/FormComponents/AddPriceList/AddPriceListMaster";
import AddTax from "../Components/FormComponents/AddSalesBillSetup/AddTax/AddTax";
import AddTaxGroup from "../Components/FormComponents/AddSalesBillSetup/AddTaxGroup/AddTaxGroup";
import AddTCS from "../Components/FormComponents/AddSalesBillSetup/AddTDSAndTSC/AddTCS";
import AddTDS from "../Components/FormComponents/AddSalesBillSetup/AddTDSAndTSC/AddTDS";
import AddConsignmentNoteRegister from "../Components/FormComponents/AddConsignmentNoteRegister/AddConsignmentNoteRegister";
import ConsignmentNote from "../Pages/ConsignmentNote/ConsignmentNote";
import AddDeliveryConfirmation from "../Components/FormComponents/AddDeliveryConfirmation/AddDeliveryConfirmation";

const ModalComponent = ({ Tablekey, prop }) => {
  // const { pushModal, popModal, getTopModal, modalStack } = useModalContext();
  console.log(Tablekey, "kkkkkkkkk", prop.Type);
  // const { title: TableTitle } = useSelector((store: any) => store?.UniqueTableReducer);
  // let name = getTopModal() || "";
  // console.log(name, "namename", modalStack);
  // const ComponentProp = useSelector((store: any) => store?.ComponentPropReducer[name]);

  const componentMapping = {
    Live_Loads: Addload,
    Vendor_Account: AddVendorAccount,
    Customer_Account: AddCustormerAccount,
    Truck_Master: AddTruckMaster,
    Vehicle_Owner_Account: AddVehicleOwnerAccount,
    Driver_Account: AddDriverAccount,
    Bank_Cash_Account: AddBankAccount,
    General_Account: AddGeneralAccount,
    Nominal_Account: AddNominalAccount,
    Bank_Payment: AddPaymentAccount,
    Bank_Receipt: AddBankReceipt,
    Cash_Receipt: AddcashReceipt,
    Cash_Payment: AddCashPayment,
    Journal_Voucher: AddJournalVoucher,
    Contra_Voucher: AddContra,
    Account_Group: AddAccountGroup,
    User_Role: AddUserRole,
    User_Entry: AddUserEntry,
    OrionAppUser: AddOrionAppUser,
    Sales_Bill: AddSalesBill,
    LMS_Sales_Bill: AddLMSSalesBill,
    Tax_Group: AddTaxGroup,
    Tax: AddTax,
    Tax_Code: AddHSN,
    Booking_Broker: AddBookingBroker,
    Voucher_Series: AddVoucherSeries,
    Receipt_Info: AddReceiptInfo,
    Consignment_Note: AddConsignmentNote,
    Page_Master: AddPageMasterData,
    Licensee_Master: AddLicense,
    Company: AddCompany,
    Branch: AddBranch,
    Menu_Master: AddMenuMaster,
    Sub_Menu: AddSubMenuMaster,
    Charge_Management: AddChargeMaster,
    Event_Master: AddEventMaster,
    Vehicle_Type: AddVehicleTypeMaster,
    Vehicle_Category: AddVehicleCategoryMaster,
    Vehicle_Length: AddVehicleLengthMaster,
    Model_Type: AddModelTypeMaster,
    LR_Delivery: AddDeliveryConfirmation,
    Delivery_Memo: AddDeliveryPlanning,
    Alert_Management: AddAlertManagement,
    Connection_Memo: AddConnectionPlanning,
    Connection_Memo_Updation: AddConnectionStatusUpdate,
    Connection_Memo_Receive: AddDestinationInward,
    Asset_Account: AddAssetAccount,
    Product_Master: AddProductMaster,
    Fields_Master: AddFieldsMaster,
    Payment_Terms: AddPaymentTermsMaster,
    User_Payment_Terms_Management: AddUserPaymentTermsManagement,
    LR_Pickup_Updation: LRPickupUpdationModal,
    "/RequestSupport": AddAdminRequestSupport,
    "/PaymentProcess": AddPaymentProcess,
    Customer_Site_Logs: CustomerLogs,
    "/BookingPage": EditBookingPageModal,
    "/Myshipments": EditBookingPageModal,
    "/THC": AddTHC,
    FTL_Consignment_Note: AddFTLConsignmentNote,
    Freight_Bill: AddFreightBill,
    City_Master: AddCityMaster,
    Place_Master: AddPlaceMaster,
    State_Master: AddStateMaster,
    Area_Master: AddAreaMaster,
    Country_Master: AddCountryMaster,
    Godown_Master: AddGodownMaster,
    District_Master: AddDistrictMaster,
    Zone_Master: AddZoneMaster,
    Pincode_Master: AddPincodeMaster,
    Financial_Master: AddFinancialMaster,
    Connection_Center: AddConnectionCenter,
    Flight_Master: AddFlightMaster,
    Material_Category: AddMaterialCategory,
    Truck_Post: AddTruck,
    Error_Logs: ErrorUserLogs,
    Emt_User_Logs: Emt_UserLogById,
    Erp_User_Logs: Erp_UserLogById,
    Stock_Group: AddStockGroup,
    Stock_Item: AddStockItem,
    Inward_Connection: AddInwardConnection,
    Emt_Accounts: AddEmtAccount,
    AccountActivity: AddEmtAccount,
    Lane_Not_Emt_Accounts: AddEmtAccount,
    KYC_Not_Emt_Accounts: AddEmtAccount,

    // AllStatusOfAccounts: AddEmtAccount,
    ERP_Address_Book_Master: AddERPAddressBookMaster,
    Contact_Person_Master: AddContactPersonMaster,
    LR_Book_Master_Data: AddLrBook,
    LR_Center_Master_Data: AddLrCenter,
    Warehouse_Master: AddWarehouseMaster,
    Pickup_Memo: AddPickupMemo,
    Part_Master_Data: AddPartMaster,
    Matching_Data: "",
    Emt_Market_Rates: AddEmtMarketRate,
    Truck_Hire_Challan: AddTHC,
    Account_Vouchers: AddLedger,
    Transaction_Checks: AddLedger,
    Payable_References: AddLedger,
    Recievable_References: AddLedger,
    Service_Type_Master: AddServiceTypeMaster,
    Emt_Table_Column_Management: AddTableColumnManagement,
    Emt_Table_Key: AddTableKey,
    Form_Keys: AddFormKey,
    EMT_Driver_Account: AddEMTDriverAccount,
    Tax_Percentage: AddTaxPercentage,
    MyShipmentTracking_Open: MyShipmentMap,
    My_Truck_Post_Live: AddMyTruck,
    My_Truck_Post_Expired: AddMyTruck,
    My_Truck_Post_All_Trucks: AddMyTruck,
    Packaging_Data: AddPackagingMaster,
    Train_Master: AddTrainMaster,
    Alert_Template: AddAlertTemplate,
    Vehicle_Management: AddVehicleManagent,
    My_Vehicle_Management: AddMyVehicleManagent,
    CN_Pickup_Updation: AddCNPickupUpdation,
    Vessel_Master: AddVesselMaster,
    FTL_CN_Delivery: AddFTLCNDelivery,

    Purchase_Bill: AddPurchaseBill,
    Claim_Sales: AddClaimSale,
    Financial_Year: AddFinancialMaster,
    MyShipmentTracking_Live: AddMyShipMentTracking,
    ShipmentTracking_Live: AddMyShipMentTracking,
    KYC_Verification: AddKYCVerification,
    Shipment_Tracking: prop.tableClick ? MyShipmentMap : AddMyShipMentTracking, //AddFTLConsignmentNote
    Credit_Note: AddNewCreditNote,
    Debit_Note: AddDebitNote,
    My_Loads: AddMyload,
    Employee_Account: AddEmployeeAccount,
    TMS_Truck_Post: AddTMSTruckPost,
    Compliances_Master: AddCompliancesMaster,
    Input_Fields: AddInputFields,
    Form_Sections: AddFormSections,
    Sales_Return: AddSalesReturn,
    PrintLayout: AddPrintLayout,
    Claims: AddClaimsComponent,
    TDS: AddTDS,
    TCS: AddTCS,
    Vendor_Freight_Bill: AddFreightBill,
    Consignment_Note_Register: prop.tableClick && prop.Type ==="FTL" ?AddFTLConsignmentNote :prop.tableClick ?AddConsignmentNote : AddConsignmentNoteRegister,
    Receivable_Account_Bill_By_Bill_Detail_View: AddLedger,
    Price_Lists_Master: AddPriceListMaster,

    // ... add any additional path-component mappings here
  };

  let Component = Tablekey ? componentMapping[Tablekey] : "";

  return Component && prop ? <Component {...prop} /> : null;
};

export default memo(ModalComponent);
